import React, { useContext, useEffect } from "react";
import { CautionIcon, RoundMinusIcon } from "~/assets/svg/InterfaceIcon";
import { PlusIcon } from "~/assets/svg/MathIcon";
import useAlert from "~/common/hooks/useAlert";
import { AppManContext } from "../../../RoundManContext";
import { useTranslation } from "react-i18next";

const ProcessThree = ({ processStep, setProcessStep }) => {
	const { t } = useTranslation();
	const { check, setCheck, outSourcing, setOutSourcing, modiData, moodi, setMoodi } =
		useContext(AppManContext);
	const [showExternalAlert, ExternalAlert] = useAlert();
	const [showEmptyAlert, EmptyAlert] = useAlert();
	const [showEmailAlert, EmailAlert] = useAlert();
	const externalList = modiData?.judge.filter((d) => d.external);

	useEffect(() => {
		if (modiData && moodi === "modi") {
			setOutSourcing(externalList);
			setCheck(modiData?.round.external);
			setMoodi("nope");
		}
	}, []);

	const handleRemoveOutSourcing = (idx) => {
		const newData = outSourcing.filter((d, index) => index !== idx);
		setOutSourcing(newData);
	};

	const handleAddOutSourcing = () => {
		setOutSourcing([
			...outSourcing,
			{ userIdx: 0, role: "심사참여", external: true, email: "", name: "", id: "", pw: "" },
		]);
	};

	const handleNameInputChange = (e, idx) => {
		const newData = outSourcing.map((d, index) =>
			index === idx ? { ...d, name: e.target.value } : d
		);
		setOutSourcing(newData);
	};

	const handleIdInputChange = (e, idx) => {
		const newData = outSourcing.map((d, index) =>
			index === idx ? { ...d, id: e.target.value } : d
		);
		setOutSourcing(newData);
	};

	const handlePasswordInputChange = (e, idx) => {
		const newData = outSourcing.map((d, index) =>
			index === idx ? { ...d, pw: e.target.value } : d
		);
		setOutSourcing(newData);
	};

	const handleEmailInputChange = (e, idx) => {
		const newData = outSourcing.map((d, index) =>
			index === idx ? { ...d, email: e.target.value } : d
		);
		setOutSourcing(newData);
	};

	const nextStepValidation = () => {
		const emailPattern =
			/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
		if (outSourcing.some((e) => e.email && !emailPattern.test(e.email))) {
			showEmailAlert();
			return;
		}
		if (check && outSourcing.length === 0) {
			showExternalAlert();
			return;
		}
		if (outSourcing.some((e) => Object.values(e).some((value) => value === ""))) {
			showEmptyAlert();
			return;
		} else {
			// return setProcessStep(processStep + 1);
			return setProcessStep(4);
		}
	};

	return (
		<>
			<div className="modal-content externalJudgeSetup">
				<div className="setup-header">
					<div className="title-wrap">
						<p className="desc">
							{t(
								"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.titleDesc"
							)}
						</p>
					</div>
					<label className="switch">
						<input type="checkbox" checked={check} onClick={() => setCheck(!check)} />
						<span className="slider round" />
						<span className="slider-label">
							{t(
								"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.sliderLabel"
							)}
						</span>
					</label>
				</div>
				<div className="c__card setup-card">
					{check ? (
						<>
							<button
								type="button"
								className="dashed-btn plus-btn"
								onClick={handleAddOutSourcing}
							>
								<PlusIcon />
								{t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.button01"
								)}
							</button>
							{outSourcing.map((d, idx) => {
								return (
									<div className="scroll-wrap" key={idx}>
										<div className="f__group-row">
											<div className="f__group">
												<div className="f__control">
													<input
														className="c__input external-name"
														placeholder={t(
															"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.namePlaceholder"
														)}
														value={d.name}
														onChange={(e) =>
															handleNameInputChange(e, idx)
														}
													/>
												</div>
											</div>
											<div className="f__group">
												<div className="f__control">
													<input
														className="c__input external-id"
														placeholder={t(
															"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.idPlaceholder"
														)}
														value={d.id}
														onChange={(e) =>
															handleIdInputChange(e, idx)
														}
													/>
												</div>
											</div>
											<div className="f__group">
												<div className="f__control">
													<input
														type="password"
														className="c__input external-pw"
														placeholder={t(
															"pages.round.RoundManage.modal.additionalRound.steps.ProFourExternal.pwPlaceholder"
														)}
														value={d.pw}
														onChange={(e) =>
															handlePasswordInputChange(e, idx)
														}
													/>
												</div>
											</div>
											<div className="f__group">
												<div
													className={`f__control ${
														d.email ? "" : "has-error"
													}`}
												>
													<input
														type="email"
														className="c__input external-email"
														value={d.email}
														placeholder={t(
															"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.emailPlaceholder"
														)}
														onChange={(e) =>
															handleEmailInputChange(e, idx)
														}
													/>
												</div>
											</div>
											<button
												type="button"
												className="btn-round-delete"
												onClick={() => handleRemoveOutSourcing(idx)}
											>
												<RoundMinusIcon />
											</button>
										</div>
									</div>
								);
							})}
						</>
					) : (
						<div className="c__noData">
							<CautionIcon />
							<p className="main">
								{t(
									"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.noDataTitle"
								)}
							</p>
							<p className="sub">
								{t(
									"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.noDataText"
								)}
							</p>
						</div>
					)}
				</div>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="gray"
					disabled={processStep === 0}
					onClick={() => setProcessStep(processStep - 1)}
				>
					{t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.prev")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={nextStepValidation}
				>
					{t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.next")}
				</button>
			</div>

			<ExternalAlert
				type="warning"
				message={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.warning"
				)}
				confirm={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.confirm"
				)}
			/>

			<EmptyAlert
				type="warning"
				message="외부심사역 정보를 입력해주세요."
				confirm={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.confirm"
				)}
			/>

			<EmailAlert
				type="warning"
				message="@를 포함한 이메일 형식으로 입력해주세요."
				confirm={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessThree.confirm"
				)}
			/>
		</>
	);
};

export default ProcessThree;
